module.exports = __webpack_public_path__ + "img/Cheer Megaphone27.bfb72646.jpg";